import React, { Component, createContext, useContext } from 'react'
import { useEnvironment } from 'contexts/environment'
import { outget } from 'api'
import PubSub from 'pubsub-js'
import { getChannel } from 'utilities/broadcaster'
import { size } from 'utilities/object'

const StaticContentContext = createContext()
StaticContentContext.displayName = 'StaticContent'

class StaticContentProvider extends Component {
    constructor(props) {
        super(props)

        this.state = {
            sales: {},
            support: {},
            contentAssistantSystemPrompt: null,
            plansBasic: null,
            plansFull: null,

            fetchFromS3: this.fetchFromS3,
            fetchContentAssistantSystemPrompt: this.fetchContentAssistantSystemPrompt,
            fetchPlansBasic: this.fetchPlansBasic,
            fetchPlansFull: this.fetchPlansFull
        }

        this.syncer = getChannel('static-content')
    }

    componentDidMount() {
        this.fetchContacts()
        this.syncer.onmessage = ({ data }) => void this.setState(data)
    }

    componentWillUnmount() {
        PubSub.unsubscribe('static-content')
        this.syncer.close()
    }

    fetchFromS3 = path => outget(`${this.props.environment.publicAssetsBucketUrl}${path}`)

    fetch = (name, path) => async () => {
        if(this.state[name]) {
            return {
                ok: true,
                response: this.state[name]
            }
        }

        const result = await this.fetchFromS3(path)

        if(result.ok) {
            this.setState(
                { [name]: result.response },
                () => this.syncer.postMessage({ [name]: result.response })
            )
        }

        return result
    }

    fetchContentAssistantSystemPrompt = this.fetch('contentAssistantSystemPrompt', '/templates/content-assistant/base.json')
    fetchPlansBasic = this.fetch('plansBasic', '/plans/basic.json')
    fetchPlansFull = this.fetch('plansFull', '/plans/full.json')

    fetchContacts = async () => {
        const urls = {
            sales: '/sales.json',
            support: '/support.json'
        }

        const results = await Promise.all(Object.values(urls)
            .map(url => this.fetchFromS3(url))
        )

        const state = results.reduce((accumulator, result, index) => {
            if(!result.ok) {
                return accumulator
            }

            return {
                ...accumulator,
                [Object.keys(urls)[index]]: result.response
            }
        }, {})

        if(size(state)) {
            this.setState(state, () => this.syncer.postMessage(state))
        }
    }

    render() {
        const { children = null } = this.props

        return (
            <StaticContentContext.Provider value={this.state}>
                {(typeof children === 'function') && children(this.state)}
                {(typeof children !== 'function') && children}
            </StaticContentContext.Provider>
        )
    }
}

export default props => {
    const { environment } = useEnvironment()

    return (
        <StaticContentProvider
            {...props}
            environment={environment} />
    )
}

export const useStaticContent = () => useContext(StaticContentContext)